(function () {
    'use strict';

    angular.module('UndergroundWebApp').controller('ContainerItemModalController', ContainerItemModalController);

    ContainerItemModalController.$inject = [
        '$timeout',
        '$scope',
        '$windowInstance',
        'containerItemService',
        'containerItemTypesService',
        'formTypes',
        'currentFormType',
        'containerItem',
        'containerId',
        '$q',
        '$rootScope'

    ];

    function ContainerItemModalController(
        $timeout,
        $scope,
        $windowInstance,
        containerItemService,
        containerItemTypesService,
        formTypes,
        currentFormType,
        containerItem,
        containerId,
        $q,
        $rootScope
    ) {

        $scope.saveItem = saveItem;
        $scope.closeWindow = closeWindow;

        $scope.isNew = containerItem ? false : true;

        $scope.containerItem = containerItem ? { ...containerItem } : { value: '', containerItemType: {}, containerId: containerId };

        //Kendo controls must be initialized after modal is created in the DOM
        $timeout(250).then(initController);

        function initController() {
        containerItemTypesService.getContainerItemTypes().then(function (result) {
            $scope.itemTypes = result || [];

            $scope.$evalAsync(function () {
            if (!$scope.containerItem.containerItemType && $scope.itemTypes.length) {
                $scope.containerItem.containerItemType = $scope.itemTypes[0];
            } else if ($scope.containerItem.containerItemType) {
                var id = $scope.containerItem.containerItemType.id;
                $scope.containerItem.containerItemType =
                $scope.itemTypes.find(function (t) { return String(t.id) === String(id); }) || null;
            }
            });
        });
        }

        //Event handlers
        function closeWindow(result) {
            $windowInstance.close(result);
        }

        function getSaveFunction(currentFormType) {
            if (currentFormType === formTypes.edit) {
                return containerItemService.updateContainerItem.bind(containerItemService);
            }

            return containerItemService.addContainerItem.bind(containerItemService);
        }

        function save() {
            var deferred = $q.defer();

            $rootScope.$broadcast('showGlobalBusyIndicator', 'containerItemIndicator');

            var saveFunction = getSaveFunction(currentFormType);

            $scope.containerItem.containerItemTypeId = $scope.containerItem.containerItemType.id;

            var dto = {
                id: $scope.containerItem.id,
                value: $scope.containerItem.value,
                containerItemTypeId: $scope.containerItem.containerItemType.id,
                containerId: $scope.containerItem.containerId
            };

            saveFunction(dto)
                .then(result => deferred.resolve(result), () => deferred.reject())
                .finally(() => $rootScope.$broadcast('hideBusyIndicator', 'containerItemIndicator'));

            return deferred.promise;
        }

        function saveItem(event, closeModal) {
            event.preventDefault();

            if ($scope.validator.validate()) {
                save().then(function (result) {
                    if (closeModal || !$scope.isNew) {
                        $windowInstance.close(result);
                    } else {
                        $scope.containerItem = { value: '', containerItemType: {}, containerId: containerId };
                    }
                });
            }
        }
    }
})();
